import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { IomService } from 'src/app/services/iom.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-analysis',
  templateUrl: './text-analysis.component.html',
  styleUrls: ['./text-analysis.component.css']
})
export class TextAnalysisComponent implements OnChanges {
  @Input()
  TextcategoryOrSubcategoryName: any;
  @Input()
  TextTicketCount: any;
  @Input() magicNumber: any;
  @Input() wordreset : boolean = true;
  inputSlider = new FormControl();

  paretoChartId: String = "paretoChartMain";
  paretoChartIdSecond: String = "paretoChartSecond";
  containerwordCloud: string = "containerwordCloud";
  VersionId: any;
  CategoryId: any;
  SubCategoryId: any;
  wordCloudData: any;
  wordCloudDataLength: any
  SubParetName: any;
  ngramValue: any = 1;
  wordLength: any = 1;
  ticketDescRow: any;
  ticketDescRowLength: any;
  ticketDescColumns: any;
  ticketDescTableDef: any;
  searchValue: any
  gridApi: any;
  gridColumnApi: any;
  isParetoExpand:boolean=false;
  constructor(private iomservice: IomService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService) { }

  ngOnChanges(): void {
    document.getElementById("closeWordCloud").style.display = "none";
    document.getElementById("wordCloudOverlay").style.display = "none";
    this.VersionId = localStorage.getItem('VersionIdMongo');
    this.CategoryId = JSON.parse(localStorage.getItem('CategoryId'));
    this.SubCategoryId = JSON.parse(localStorage.getItem('SubCategoryId'));
    this.spinner.show();
    // if (this.CategoryId == null) {
    //   this.CategoryId = 0;
    // }
    // if (this.SubCategoryId == null) {
    //   this.SubCategoryId = 0;
    // }
    this.getInitailCharts(this.VersionId, this.CategoryId, this.SubCategoryId);
    this.inputSlider.setValue(1);
    this.changeNgram(1);
  }

  getInitailCharts(versionId: any, categoryId: any, subCategoryId: any) {

    this.spinner.show();
    this.wordCloudData = null;
    this.wordCloudDataLength = 0;
    this.iomservice.TextAnaylsisWordCloud(versionId, categoryId, subCategoryId, this.ngramValue).subscribe(data => {      
      this.wordCloudData = data
     // this.wordCloudData = JSON.parse(this.wordCloudData)
      this.wordCloudDataLength = Object.keys(this.wordCloudData).length;

      document.getElementById('drillPareto').style.display = "none";
      document.getElementById('expdrillPareto').style.display = "none";
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error occured in Loading Text Analysis!");
      });
    this.changeNgram(1);
    this.getTicketDescription(versionId, categoryId, subCategoryId)
  }

  changeNgram(number: any) {
    if (this.wordreset = true){
      this.ngramValue = 1
    }
    this.ngramValue = number;
  
    this.getNgramData(this.VersionId, this.CategoryId, this.SubCategoryId, this.ngramValue)
    var drilllP = document.getElementById('drillPareto')
    if (drilllP != null) {
      drilllP.style.display = "none";
    }
    var drilllP = document.getElementById('expdrillPareto')
    if (drilllP != null) {
      drilllP.style.display = "none";
    } 
  }

  getNgramData(id: any, categoryId: any, subCategory: any, value: any) {
    this.spinner.show();
    this.wordCloudData = null;
    this.wordCloudDataLength = 0;
   // document.getElementById('container_wordCloud').style.display = "none";
    this.iomservice.TextAnaylsisWordCloud(id, categoryId, subCategory, value).subscribe(data => {
      if(data!=null){      
      this.wordCloudData = data
      //this.wordCloudData = JSON.parse(this.wordCloudData)
      this.wordCloudDataLength = Object.keys(this.wordCloudData).length;
    }
      this.spinner.hide();
   //   document.getElementById('container_wordCloud').style.display = "block";
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error occured in Loading Text Analysis!");
      });
  }
  subParetoHandler(name: any) {
    this.SubParetName = name;
  }
  getTicketDescription(id: any, categoryId: any, subCategory: any = "none") {
    this.spinner.show();
    this.iomservice.TextAnaylsisTrend(id, categoryId, subCategory).subscribe(data => {
      if(data!=null){
      this.ticketDescRow = data;
     // this.ticketDescRow = JSON.parse(this.ticketDescRow)
      this.ticketDescRowLength = Object.keys(this.ticketDescRow).length;
    }
      // this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error occured in Loading Text Analysis!");
      });
    this.ticketDescTableDef = {
      editable: true,
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: true,
      flex: 1
    };
    this.ticketDescColumns = [
      { headerName: 'Number', field: 'IncidentNumber', width: 150 },
      { headerName: 'Description', field: 'RawDescription', width: 550 }
    ];
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  onFirstDataRendered(params) {
    params.api.sizeColumnsToFit();
  }
  ExpandParetoChart(){
    this.isParetoExpand = true;
  }
  closeExpand(){
    this.isParetoExpand = false;
    var drilllP = document.getElementById('expdrillPareto')
    if (drilllP != null) {
      drilllP.style.display = "none";
    } 
  }
  expandWordCloud(){  
    document.getElementById("closeWordCloud").style.display = "block"; 
    document.getElementById("wordCloudOverlay").style.display = "block"; 
    var expandWordID = document.getElementById('wordcloudExpand')
    if (expandWordID != null) {
      expandWordID.style.display = "none";
    } 
    $('#wordcloudExpand').addClass("wordcloudContainerExp");
    $("#wordcloudContent").addClass("wordcloudExp");
    $("#wordCloudOverlay").addClass("wordCloudoverlay");
    $("#wordcloudexpandText").addClass("sub-highlight-text");
  }

  closeExpandWord(){
    document.getElementById("closeWordCloud").style.display = "none";
    document.getElementById("wordCloudOverlay").style.display = "none"; 
    $('#wordcloudExpand').removeClass("wordcloudContainerExp");
    $("#wordcloudContent").removeClass("wordcloudExp");
    $("#wordCloudOverlay").removeClass("wordCloudoverlay");
    $("#wordcloudexpandText").removeClass("sub-highlight-text");
  }
}
